const resumeData = {
  imagebaseurl: "https://github.com/AhmedAdelAlemam",
  target: "_blank",
  img: "/images/me.jpg",
  name: "Ahmed Adel Alemam",
  summary:
    "Self-motivated Front end developer adds high level of experience over more than 4 years collaborating and working on multiple web-based projects. Passionate, hardworking coder with penchant for developing customized interfaces that factor in unique demands for accessibility, reachability and security. Organized approach to meeting multiple, concurrent deadlines. Pulls from active knowledge of current technology landscape to promote best practices in web design",
  address: "Cairo, Egypt",
  mobile: "(+20)1098981808",
  mail: "ahmedemam755@gmail.com",
  udacitySite: "https://udacity.com",
  udacity: "https://www.udacity.com/course/front-end-web-developer-nanodegree--nd001",
  udaciDescription:
    "Demand for front end developers is widespread across every industry and continues to rise. By mastering the valuable skills taught in this program, you’ll be prepared for roles at a wide array of companies, from startups to global organizations. The projects you’ll build, and the portfolio you’ll develop, will provide ample evidence of your expertise",
  univ: "Ain Shams",
  faculty: "Faculty of Law",
  lawDesc: "The College is awarded a Bachelor's degree after successfully passing all the subjects in the four years",
};
export default resumeData;
